export const environment = {
  production: true
};



// WEBPACK FOOTER //
// /home/ubuntu/taxpadweb/src/environments/environment.ts